/**
 * 搜索栏公共组件
 */
<template>
  <div>
    <slot name="hint1"></slot>
    <v-scrollbar v-if="hasScroll" :settings="settings" class="search-form-box-scroll">
      <el-form
        ref="formRef"
        v-enterToNext="true"
        :model="formData"
        :inline="isInline"
        :label-width="labelWidth"
      >
        <el-form-item
          v-for="(item, index) in formOptions"
          v-show="!item.hide"
          :key="newKeys[index]"
          :prop="item.prop"
          :label="item.label ? (item.label + '：') : item.labelWithoutDot ? item.labelWithoutDot : ''"
          :rules="item.rules"
        >
          <slot v-if="item.slot" :name="item.slotName"></slot>
          <formItem
            v-else
            v-model="formData[item.prop]"
            :item-options="item"
          />
        </el-form-item>
      </el-form>
    </v-scrollbar>
    <div v-else class="search-form-box">
      <el-form
        ref="formRef"
        :model="formData"
        :inline="isInline"
        :label-width="labelWidth"
      >
        <el-form-item
          v-for="(item, index) in formOptions"
          v-show="!item.hide"
          :key="newKeys[index]"
          :prop="item.prop"
          :label="item.label ? (item.label + '：') : item.labelWithoutDot ? item.labelWithoutDot : ''"
          :rules="item.rules"
        >
          <slot v-if="item.slot" :name="item.slotName"></slot>
          <formItem
            v-else
            v-model="formData[item.prop]"
            :item-options="item"
          />
        </el-form-item>
      </el-form>
    </div>
    <slot name="otherFormItem"></slot>
    <!-- 提交按钮 -->
    <div v-if="withLine" class="asLine"></div>
    <div class="btn-box">
      <el-button
        v-if="btnItems.includes('reset')"
        size="mini"
        type="default"
        class="btn-reset"
        @click="onReset"
      >{{ $t('重置') }}</el-button>
      <el-button
        v-if="btnItems.includes('search')"
        size="mini"
        type="primary"
        class="btn-search"
        @click="onSearch"
      >{{ $t('查询') }}</el-button>

      <el-button
        v-if="btnItems.includes('export')"
        size="mini"
        type="primary"
        class="btn-export"
        @click="onExport"
      >{{ $t('导出') }}</el-button>
      <el-button
        v-if="btnItems.includes('cancel')"
        size="mini"
        type="normal"
        class="btn-cancel"
        @click="onCancel"
      >{{ $t('取消') }}</el-button>
      <el-button
        v-if="btnItems.includes('confirm')"
        size="mini"
        type="primary"
        class="btn-search"
        @click="onConfirm"
      >{{ $t('提交') }}</el-button>
      <el-button
        v-if="btnItems.includes('checkConfirm')"
        size="mini"
        type="primary"
        class="btn-search"
        @click="onConfirm"
      >{{ $t('确定') }}</el-button>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
// import tools from '@klinx/utils/tool'
import * as utilBasic from '@klinx/utils/index'
import { mapState } from 'vuex'
export default {
  components: { },
  props: {
    hasScroll: {
      type: Boolean,
      default() {
        return false
      }
    },
    isInline: {
      type: Boolean,
      default() {
        return true
      }
    },
    /**
     * 表单配置
     * 示例：
     * [{
     *   label: this.$t('用户名'), // label文字
     *   prop: 'username', // 字段名
     *   element: 'el-input', // 指定elementui组件
     *   initValue: this.$t('阿黄'), // 字段初始值
     *   placeholder: this.$t('请输入用户名'), // elementui组件属性
     *   rules: [{ required: true, message: this.$t('必填项'), trigger: 'blur' }], // elementui组件属性
     *   events: { // elementui组件方法
     *     input (val) {
     *       console.log(val)
     *     },
     *     ...... // 可添加任意elementui组件支持的方法
     *   }
     *   ...... // 可添加任意elementui组件支持的属性
     * }]
     */
    formOptions: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    labelWidth: {
      type: String,
      default() {
        return '130px'
      }
    },
    // 提交按钮项，多个用逗号分隔（search, export, reset）
    btnItems: {
      type: String,
      default() {
        return ''
      }
    },
    withLine: {
      type: Boolean,
      default() {
        return false
      }
    },
  },

  data() {
    return {
      formData: {},
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false
      }
    }
  },
  computed: {
    ...mapState('info', {
      state: state => state
    }),
    newKeys() {
      return this.formOptions.map(v => {
        return utilBasic.createUniqueString()
      })
    }
  },
  created() {
    this.addInitValue()
  },
  mounted() {
    this.addInitValue()
  },
  methods: {  
    modifyData(dt){
      this.formData = {
        ...this.formData,
        ...dt
      }
    },
    // 校验
    onValidate(callback) {
      this.$refs.formRef.validate(valid => {
        this.$emit('onValidate', valid)
        if (valid) {
          callback()
        }
      })
    },
    // 搜索
    onSearch() {
      this.onValidate(() => {
        this.$emit('onSearch', this.formData)
      })
    },
    // 导出
    onExport() {
      this.onValidate(() => {
        this.$emit('onExport', this.formData)
      })
    },
    onReset() {
      this.$emit("onReset", this.formData)
      this.$refs.formRef.resetFields()
    },
    // 确定
    onConfirm() {
      this.onValidate(() => {
        this.$eventBus.$emit('btnClicked', 'original')
        this.$emit('onConfirm', this.formData)
      })
    },
    // 取消
    onCancel() {
      this.$emit('cancel', this.formData)
    },
    // 添加初始值
    addInitValue() {
      const obj = {}
      this.formOptions.forEach(v => {
        if (v.initValue !== undefined) {
          obj[v.prop] = v.initValue
        }
      })
      this.formData = obj
    }
  }
}
</script>

<style lang='less' scoped>
.btn-search,.btn-export{
  border: 1px solid #FF6900;
  background: #FF6900;
}

.asLine{
  width:108%;
  height:1px;
  background:#E9E9E9;
  position: relative;
  left:50%;
  top: 13px;
  transform: translate(-50%, 0);
  margin-bottom:23px;
}
.search-form-box {
  display: flex;
  min-height:32px;
  position: relative;
  // width:100%;
  // max-height: 350px;
  // margin-bottom: 15px;
  .btn-box {
    padding-top: 5px;
    display: flex;
    margin-left:20px;
    button {
      height: 32px;
    }
  }
  .el-form {
    ::v-deep .el-form-item__label {
      padding-right: 0;
      height:32px;
      line-height:32px;
      // min-width:115px;
    }
    .el-form-item {
      min-height:32px;
      line-height:32px;
      margin-bottom: 24px;
      // margin:5px 0;
      &.is-error {
        margin-bottom: 22px;
      }
    }
    ::v-deep.el-form-item__content {
      // height:32px;
      line-height:32px;
    }
    // el-input宽度
    ::v-deep .form-item {
      > .el-input:not(.el-date-editor) {
        width: 200px;
        .el-input__inner {
          height:32px;
          line-height:32px;
        }
      }
    }

    ::v-deep .el-textarea {
      width: 200px
    }

    ::v-deep .el-select {
      width: 200px;
      .el-input__inner {
        height:32px;
        line-height:32px;
      }
    }
    ::v-deep .el-cascader {
      width: 200px;
      .el-input__inner {
        height:32px;
        line-height:32px;
      }
    }
    ::v-deep .el-date-editor{
      height:32px;
      line-height:32px;
    }
  }

  .el-form--inline{
    .el-form-item {
      margin-bottom: 0px;
    }
  }
}

.search-form-box-scroll {
  display: flex;
  min-height:32px;
  position: relative;
  // width:100%;
  max-height: 350px;
  // margin-bottom: 15px;
  .btn-box {
    padding-top: 5px;
    display: flex;
    margin-left:20px;
    button {
      height: 32px;
    }
  }
  .el-form {
    ::v-deep .el-form-item__label {
      padding-right: 0;
      height:32px;
      line-height:32px;
      // min-width:115px;
    }
    .el-form-item {
      min-height:32px;
      line-height:32px;
      margin-bottom: 24px;
      // margin:5px 0;
      &.is-error {
        margin-bottom: 22px;
      }
    }
    ::v-deep.el-form-item__content {
      height:32px;
      line-height:32px;
    }
    // el-input宽度
    ::v-deep .form-item {
      > .el-input:not(.el-date-editor) {
        width: 200px;
        .el-input__inner {
          height:32px;
          line-height:32px;
        }
      }
    }

    ::v-deep .el-textarea {
      width: 200px
    }

    ::v-deep .el-select {
      width: 200px;
      .el-input__inner {
        height:32px;
        line-height:32px;
      }
    }
    ::v-deep .el-cascader {
      width: 200px;
      .el-input__inner {
        height:32px;
        line-height:32px;
      }
    }
    ::v-deep .el-date-editor{
      height:32px;
      line-height:32px;
    }
  }

  .el-form--inline{
    .el-form-item {
      margin-bottom: 0px;
    }
  }
}

</style>
